import React, { Component } from 'react'
import { FormRadio } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { observer } from 'mobx-react'
import Store from '../../stores/Store'
import FormHelper from '../../utils/FormHelper'

@observer
class Radio extends Component {
  static propTypes = {
    ...FormRadio.propTypes,
    store: PropTypes.instanceOf(Store).isRequired,
    defaultValue: PropTypes.any,
    name: PropTypes.string.isRequired,
    value: PropTypes.any,
    checked: PropTypes.bool, // if not provided, value will be calculated
    renderOnSelect: PropTypes.element
  }

    handleOnChangeRadio = (e, data) => {
      const { store, name } = this.props
      store.set(name, FormHelper.convertToValue(data.value))
      const error = _.get(store.errorMessages, name, undefined)
      if (error) {
        _.unset(store.errorMessages, name)
      }
    }

    render () {
      const { store, name, options, value, onChange, checked, renderOnSelect, defaultValue, ...props } = this.props
      let varValue = _.get(store, name, '')
      if (defaultValue && varValue === null) {
        varValue = defaultValue
      }
      varValue = FormHelper.convertToString(varValue)
      const propValue = FormHelper.convertToString(value)
      const error = _.get(store.errorMessages, name, undefined)
      return (
        <>
          <FormRadio
            checked={checked !== undefined ? checked : varValue === propValue}
            value={propValue}
            name={name}
            error={error}
            onChange={onChange || this.handleOnChangeRadio}
            {...props}
          />
          {checked ? renderOnSelect : []}
        </>
      )
    }
}
export default Radio
